import { createApi } from '@reduxjs/toolkit/query/react';
import { onePassFetchBase } from '~/api/baseFetch';
import {
  TOnePassAddQrcodeIdPayload,
  TOnePassGetQrcodeTicketPayload,
  TOnePassGetQrcodeTokenPayload,
} from '~/api/onePass/onepass.type';
import { APIResponse } from '~/api/baseFetch/common.type';

export const onePassApi = createApi({
  reducerPath: 'onePassApi',
  baseQuery: onePassFetchBase,
  endpoints: builder => ({
    getQrcodeTicket: builder.query<
      APIResponse<string>,
      TOnePassGetQrcodeTicketPayload
    >({
      query: data => ({
        url: '/qrcode/getTicket',
        method: 'POST',
        body: data,
      }),
    }),
    getQrcodeToken: builder.query<
      APIResponse<string>,
      TOnePassGetQrcodeTokenPayload
    >({
      query: data => ({
        url: '/qrcode/getToken',
        method: 'POST',
        body: data,
      }),
    }),
    addQrcodeId: builder.query<APIResponse<string>, TOnePassAddQrcodeIdPayload>(
      {
        query: data => ({
          url: '/qrcode/add',
          method: 'POST',
          body: { id: data.id },
          headers: {
            Authorization: data.token,
          },
        }),
      },
    ),
  }),
});

export const {
  useGetQrcodeTicketQuery,
  useGetQrcodeTokenQuery,
  useLazyGetQrcodeTicketQuery,
  useLazyGetQrcodeTokenQuery,
  useLazyAddQrcodeIdQuery,
} = onePassApi;
